/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $Sprite,
    $Container,
    ExtendContainerProps,
    $SetVisibility,
    getProp,
    patchEvents,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';

type BaseCheckboxProps = {
    disabled?: boolean;
    texturePrefix?: string;
    action?: (val: boolean) => void;
    value: boolean;
};

export type CheckboxProps = ExtendContainerProps<BaseCheckboxProps>;

const CHECKBOX_STATES = [
    'on_disabled', 'on_focused', 'on_pressed', 'on_normal',
    'off_disabled', 'off_focused', 'off_pressed', 'off_normal',
];

export const $Checkbox: FC<CheckboxProps> = (props) => {
    const focused = Store.signal(false);
    const pressed = Store.signal(false);
    const enabled = Store.computed(() => !getProp(props.disabled));

    props.texturePrefix ??= 'radio_btn';

    const selected = Store.computed(() => {
        const value = getProp(props.value);
        const state = value ? 'on' : 'off';
        let variant = focused.value ? 'focused' : 'normal';

        variant = pressed.value ? 'pressed' : variant;

        if (getProp(props.disabled)) {
            variant = 'disabled';
        }

        return `${state}_${variant}`;
    });

    const stateComponents = Store.computed(() => {
        const texturePrefix = getProp(props.texturePrefix);

        return CHECKBOX_STATES.map(state =>{
            const texture = `${texturePrefix}_${state}_sys_ui`;

            return <$Sprite
                name={state}
                anchor={0.5}
                texture={texture}
            />;
        });
    });

    const toggle = () => {
        const action = getProp(props.action);
        const newVal = !getProp(props.value);

        action?.(newVal);
    };

    const setHoverTrue = () => focused.value = true;
    const setHoverFalse = () => focused.value = false;
    const setPressTrue = () => pressed.value = true;
    const setPressFalse = () => pressed.value = false;

    props.events ??= {};
    patchEvents(props.events, {
        pointerover: setHoverTrue,
        pointerout: setHoverFalse,
        pointerdown: setPressTrue,
        pointerup: setPressFalse,
        pointertap: toggle,
        pointerupoutside: setPressFalse,
    });

    // responsiveSkipChildren(props);

    return <$Container
        interactive={enabled}
        buttonMode={enabled}
        {...props}
    >
        <$SetVisibility selector={selected}>
            {stateComponents}
        </$SetVisibility>
    </$Container>;
};